export function setExpandoStatus(state, payload) {
  return {
    ...state,
    expandosStatus: { ...state.expandoStatus, ...payload },
  };
}

// expandosStatus: {
//     profile: true,
//     community: true
// }
